import { render, staticRenderFns } from "./SidebarActions.vue?vue&type=template&id=5b0d520b&scoped=true"
import script from "./SidebarActions.vue?vue&type=script&lang=js"
export * from "./SidebarActions.vue?vue&type=script&lang=js"
import style0 from "./SidebarActions.vue?vue&type=style&index=0&id=5b0d520b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0d520b",
  null
  
)

export default component.exports